import axios from "axios";
import _ from "lodash";
import { Logger } from "../logging/logger";
import PageConfig from "../utils/PageConfig";

export const getPreview = async (
  instructionsUrl: string,
  productKey: string,
  version: number,
  selection: Record<string, string>,
  locale: string
): Promise<Previews | undefined> => {
  const baseUrl = `https://lookup.previews.cimpress.io/api/v1/vistaprint-prod/${locale.toLowerCase()}/product/${productKey}/allViews`;
  try {
    const url = `${baseUrl}?previewInstructionsUri=${encodeURIComponent(
      instructionsUrl
    )}&purpose=design.studio.review&requestor=${
      PageConfig.requestor
    }&optionSelections=${encodeURIComponent(
      JSON.stringify(selection)
    )}&productVersion=${version}&width=1700`;

    const response = await axios.get(url);
    if (response.data) {
      return response.data;
    }
  } catch (e) {
    Logger.instance.error("Failed to get lookup preview", {
      productKey,
      version,
      selection,
      locale,
      instructionsUrl,
      error: e,
    });
  }
  return undefined;
};

interface GalleryViewLink {
  href: string;
  title?: string;
}

interface GalleryViewLinks {
  image: GalleryViewLink;
}

interface GalleryView {
  name: string;
  sceneType: string;
  width: number;
  height: number;
  _links: GalleryViewLinks;
}

interface Previews {
  views: GalleryView[];
}
